import { ChevronRight } from 'lucide-react';
import Link from 'next/link';

const variants = {
    dark: {
        chevron: 'text-white/50',
        link: 'text-white/90 font-semibold hover:text-white transition-colors',
        current: 'text-white font-semibold',
        separator: 'text-white/50',
        backLink:
            'text-white/80 font-semibold hover:text-white transition-colors',
    },
    light: {
        chevron: 'text-gray-400',
        link: 'text-gray-500 font-semibold hover:text-gray-900 transition-colors',
        current: 'text-gray-900 font-semibold',
        separator: 'text-gray-400',
        backLink:
            'text-gray-500 font-semibold hover:text-gray-900 transition-colors',
    },
};

const Breadcrumb = ({ items = [], backLabel, variant = 'dark', ...rest }) => {
    const s = variants[variant] ?? variants.dark;

    return (
        <nav
            className="flex flex-wrap items-center gap-2 text-sm"
            aria-label="Breadcrumb"
            {...rest}
        >
            <ol className="flex flex-wrap items-center gap-2">
                {items.map((crumb, idx) => (
                    <li
                        key={crumb.href ?? crumb.label ?? `crumb-${idx}`}
                        className="flex items-center gap-2"
                    >
                        {idx > 0 && (
                            <ChevronRight
                                className={`h-3 w-3 shrink-0 ${s.chevron}`}
                                aria-hidden="true"
                            />
                        )}
                        {crumb.href ? (
                            <Link
                                href={crumb.href}
                                className={`whitespace-nowrap ${s.link}`}
                            >
                                {crumb.label}
                            </Link>
                        ) : (
                            <span className={`whitespace-nowrap ${s.current}`}>
                                {crumb.label}
                            </span>
                        )}
                    </li>
                ))}
            </ol>
            {backLabel && (
                <>
                    <span className={s.separator} aria-hidden="true">
                        ·
                    </span>
                    <Link
                        href={items.findLast((c) => c.href)?.href ?? '/'}
                        className={`whitespace-nowrap ${s.backLink}`}
                    >
                        {backLabel}
                    </Link>
                </>
            )}
        </nav>
    );
};

export default Breadcrumb;
